import logo from '@/assets/logo.png'
import { Divider, Spin } from 'antd'
import Title from 'antd/es/typography/Title'
import React, { memo, Suspense, useMemo } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import styles from './index.module.less'
import classNames from 'classnames'

export default memo(function EntranceLayout() {
  let location = useLocation()
  const searchStr = window.location.search

  const title = useMemo(() => {
    const pathName = location.pathname;
    if (pathName === '/entrance/change-password') {
      return 'Change your password'
    } else if(pathName.startsWith('/entrance/reset-password')) {
      return 'Reset your password'
    } else if(pathName.startsWith('/entrance/forgot-password')) {
      return 'Account Recovery'
    } else {
      return 'Welcome to Orbit'
    }

  }, [location.pathname])

  return (
    <div className={styles.container}>
      <div style={{
        width: '100%',
        height: '100%',
        background: 'linear-gradient(180deg, rgba(26, 141, 95, 0.85) 0%, rgba(0, 59, 35, 0.85) 100%)'}}>
        <header className={styles.header}>
          <div>
          </div>
          <div>
            {location.pathname === '/entrance/login' && (
              <div>
                <span>New to Orbit? Create an account.</span>
                <Link to={`/entrance/register${searchStr}`}>Sign up</Link>
              </div>
            )}
            {location.pathname === '/entrance/register' && (
              <div>
                <span>Already playing with Orbit?</span>
                <Link to={`/entrance/login${searchStr}`}>Login</Link>
              </div>
            )}
          </div>
        </header>
        <div className={styles.content}>
            <div className='flex-center'>
              <img src={logo} />
            </div>
            <div className={classNames(styles.form)}>
              <Title level={2}>{title}</Title>
              <Divider />
              <Suspense fallback={<Spin size='large' tip='Loading...' />}>
                <Outlet />
              </Suspense>
            </div>
        </div>
      </div>
    </div>
  )
})
